import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { ParticipantsTable } from 'modules/trainings/components/Revamp/TrainingsDetail/Classes/EditClass/ParticipantsTab/ParticipantsTable'

const ParticipantsTab = () => {
  const { id, classId } = useParams()
  const { canEdit } = useOutletContext<{ canEdit: boolean }>()

  return (
    <>
      <ParticipantsTable classId={String(classId)} canEdit={canEdit} id={String(id)} />
      <Outlet />
    </>
  )
}

export default ParticipantsTab
